/* This function is used in components that fetch orders */

import type { IOrder } from '@rogue/universal'
import updateOrderInfo from './update-order-info'
import type { IRogue } from '@/js/services/RogueTypes'

type OrderListResponse = {
  orders: IOrder[];
  count: number;
}

export async function fetchOrders(rogue: IRogue, number?: number, page: number = 1, view: string = 'all'): Promise<OrderListResponse> {
  try {
    let fetchUrl = '/svc_checkout/order'
    if (number && number > 0) {
      fetchUrl += `?page=${page}&limit=${number}&view=${view || 'all'}`
    }

    const ordersResponse = await rogue.fetch<OrderListResponse>(fetchUrl)
    ordersResponse.orders.forEach(order => {
      if (order) {
        updateOrderInfo(order, rogue)
      }
    })

    return ordersResponse
  } catch (e: any) {
    rogue.log.error('Could not load orders', e)

    return {
      orders : [],
      count  : 0,
    }
  }
}
